export enum FLP360Status {
    Active = 1,
    Suspended = 2,
    NoSubscription = 3,
    Restricted = 4,
    Activation_Pending = 5
}
